export { default } from '../search/home';